(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','APP','$mdAriaProvider','$mdDateLocaleProvider'];

    function stateConfig($stateProvider,APP,$mdAriaProvider,$mdDateLocaleProvider) {
    		
    	
        	$stateProvider.state('users', {
            parent: 'app',
            url: '/users',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            views: {
                'dynamicView': {
                    templateUrl: 'app/user/user.management.html',
                    controller: 'UserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('user.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('user.json?timestamp='+new Date().getTime());
                       }
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                /*mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("1");
                	$timeout(function() {
                	    angular.element('#internalUser').triggerHandler('click');
                	  });
                }],*/
                'redirect' : ['Principal', '$state', '$timeout', function(Principal, $state, $timeout){
       	    		$timeout(function(){
       	    			if(Principal.isAuthenticated()) {
       		    			return true;
       		    		} else {
       		    			$state.go('login');
       		    			return false;
       		    		}
       	    		}, 700)
       	    	 }]
            }
        });
    }
})();
